import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from './service'

export const getNominalGDP = createAsyncThunk(
  'companyAnalysis/industryOverview/macroeconomics/gdp/getNominalGDP',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.getNominalGDP(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getRealGDP = createAsyncThunk(
  'companyAnalysis/industryOverview/macroeconomics/gdp/getRealGDP',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.getRealGDP(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
